module.exports = __webpack_public_path__ + "img/fm-screen-4.fdaa4a43.webp";